import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ReactSVG } from 'react-svg';
import { resetGameUrl } from '../store/actionCreators/gameUrl';
import { getGameBoxView, getGameUrl } from '../store/selectors';
import { isValidURL } from '../utils/utils';
import cn from "classnames";
import { changeGameBoxView } from "../store/actionCreators/ui";

interface ErrorMessageProps {
    resetError?: () => void;
}
const ErrorMessage: FC<ErrorMessageProps> = () => {
    const { t } = useTranslation();
    const iframeUrl = useSelector(getGameUrl);
    const dispatch = useDispatch();
    const gameBoxView = useSelector(getGameBoxView);
    const isWidget = gameBoxView === 'widget';

    const onClose = (): void => {
        window.location.reload();
        isWidget
            ? window.parent.postMessage({ type: 'CLOSE_GAME_BOX_GLOBAL_WIDGET' }, '*')
            : window.parent.postMessage({ type: 'CLOSE_GAME_BOX' }, '*');
        dispatch(resetGameUrl());
        dispatch(changeGameBoxView(''));
    };

    return (
        <div className="error-boundary">
            <div className={cn('game-header', {
                'header_game_mode': iframeUrl
            })}>
                <p className="error_txt">{t('error_msg')}</p>
                <span className="game__close-icon" onClick={onClose}>
          <ReactSVG src="/static/images/close.svg" onClick={() => onClose} />
        </span>
            </div>
            {iframeUrl && isValidURL(iframeUrl) && !iframeUrl.includes("casinorace") && (
                <div className="game-mod-view">
                    <iframe src={iframeUrl} frameBorder={0} width="100%" height="100%" title="gameMode" className="fullScreen" />
                </div>
            )}
        </div>
    );
};

export default ErrorMessage;
